import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CompartilhadoService } from 'src/app/services/compartilhado/compartilhado.service';
import { PerfilService } from 'src/app/services/controle-de-acesso/perfil.service';
import { MenuModel } from 'src/app/models/perfil.model';
import { UsuarioService } from 'src/app/services/controle-de-acesso/usuario.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public omitirMenu: boolean = true;
  public menus: any = [];
  public subMenusAbertos: { [menuId: string]: boolean } = {};
  public perfil: MenuModel;
  public perfilMenu: MenuModel;

  constructor(
    public compartilhadoService: CompartilhadoService,
    private cd: ChangeDetectorRef,
    private usuarioService: UsuarioService
  ) { }

  ngOnInit() {
    this.usuarioService.perfil().subscribe(
      _=> { 
        const perfil = localStorage.getItem('perfil');
        this.perfilMenu = JSON.parse(perfil);

        // Inicializa todos os submenus como abertos
        if (this.perfilMenu?.menus?.length) {
          this.perfilMenu.menus.forEach(menu => {
            this.subMenusAbertos[menu.id || menu.descricao] = true;
          });
        }

        this.cd.detectChanges();
      }
    );
  }
}
